
import Hero from './components/Hero';
import ServicesSection from './components/ServicesSection';
import PlatformsSection from './components/PlatformsSection';
import CtaSection from './components/CtaSection';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <ServicesSection />
      <PlatformsSection />
      <CtaSection />
      <Footer />
    </div>
  );
}
